import _escapeRegExp from 'lodash-es/escapeRegExp';

/**
 * Highlights matching text segments in a string by wrapping them with <strong> tags.
 * Supports accent-tolerant matching for French characters (e, é, è, ê, ë).
 *
 * @param text - The text to search within
 * @param query - The search query to highlight
 * @returns The text with matching segments wrapped in <strong> tags
 */
export function boldMatchingText(text: string, query?: string): string {
  if (!query) {
    return text;
  }

  const items = query
    .replaceAll(/[-']/g, ' ') // handle special chars as spaces for search
    .replaceAll(/  +/g, ' ') // remove multiple spaces for sanity
    .trim()
    .split(' ')
    .filter(item => item.length > 0) // filter out empty strings
    .sort((a, b) => b.length - a.length); // sort by length to replace the longest first

  if (items.length === 0) {
    return text;
  }

  const str = items.reduce((acc, item) => {
    const accentTolerantItem = _escapeRegExp(item) // protège les caractères spéciaux comme *
      .replaceAll(/[eéèêë]/gi, '[eéèêë]'); // ecole, école, Ecole, etc.
    const regex = new RegExp(`(${accentTolerantItem})`, 'gi');
    return acc.replace(regex, '((((($1)))))'); // use placeholders to prevent "s.t.r.o.n.g." letters to be replaced
  }, text);

  return str.replaceAll('(((((', '<strong>').replaceAll(')))))', '</strong>');
}
